import { SelectInput } from '@frontend/basic-forms';
import React from 'react';

import useNotificationChannelSelect from './notification-channel-select.controller';

const ID = 'notification-channel-select';

export interface NotificationChannelSelectProps {
    value?: { value: string; label: string } | string;
    id?: string;
    required?: boolean;
    submitted: boolean;
    label?: string;
    onChange: (value: any) => void;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
}

export const NotificationChannelSelect = (props: NotificationChannelSelectProps) => {
    const viewProps = useNotificationChannelSelect(props);

    return (
        <SelectInput
            id={props.id || ID}
            label={props.label || 'Notification channel'}
            className={props.className}
            submitted={props.submitted}
            required={props.required}
            options={viewProps.options}
            onChange={props.onChange}
            value={viewProps.value}
            isDisabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
